import BaseService from "@/services/BaseService";
import * as URI from "../communication/constant";

const action = {
  async getCommunicationsAction({ commit }, payload) {
    let url = URI.SCHEDULE_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const communication = await BaseService.getSchemePlanningClient().get(url);
    commit("setCommunications", communication.data.data);
    return communication.data.data;
  },
  async getGeneralMasterAction({ commit }) {
    const masterData = await BaseService.getSchemePlanningClient().get(
      URI.SCHEDULE_DATA_URL
    );
    commit("setGeneralMaster", masterData.data.data);
  },
  async getPlanListsAction({ commit }, payload) {
    const planList = await BaseService.getSchemePlanningClient().put(
      URI.PLAN_LIST_URL,
      payload
    );
    commit("setPlanLists", planList.data.data);
    return planList.data.data;
  },
  async saveGeneralDataAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.ADD_SCHEDULE_URL,
      payload
    );
    return response.data.data;
  },
  async importCsvRenderEmailAction({ commit }, payload) {
    let url = URI.CSV_RENDER_EMAIL_URL.replace(
      "{emailGroupTypeId}",
      payload.emailGroupTypeId
    )    
    .replace("{division}", payload.division)
    .replace("{channel}", payload.channel)
    .replace("{planAssociationId}", payload.planAssociationId)
    .replace("{isSchemeBased}", payload.isSchemeBased);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  updateCreateScheduleForm({ commit }, payload) {
    commit("setCreatescheduleForm", payload);
  },
  async deleteCommunicationSchedule({ commit }, payload) {
    const url = URI.DELETE_COMMUNICATION_SCHEDULE_URL.replace(
      "{scheduleNumber}",
      payload.scheduleNumber
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  async deletePlanListSchedule({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.DELETE_PLAN_LIST_SCHEDULE_URL,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async deletePartnerHoSaleEmail({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.DELETE_PARTNER_HO_SALES_LIST_EMAIL_URL,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async deleteEmailAttachment({ commit }, payload) {
    const url = URI.DELETE_SCHEDULE_ATTACHMENT_URL.replace(
      "{payload}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  async getEmailAttachmentUploadAction({ commit }, payload) {
    const url = URI.SCHEDULE_ATTACHMENT_UPLOAD_URL.replace(
      "{scheduleNumber}",
      payload.scheduleNumber
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.file,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async getScheduleEmailDataDetails({ commit }, payload) {
    const url = URI.SCHEDULE_ATTACHMENT_URL.replace("{payload}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getPlanRenderEmailAction({ commit }, payload) {
    let role = "";
    if(payload.role) {
      role =  payload.role;
    }
    let url = URI.PLAN_RENDER_EMAIL_URL.replace(
      "{groupId}",
      payload.groupId
    ).replace("{planNumber}", payload.planNumber)
    .replace("{planAssociationId}", payload.planAssociationId);
    const response = await BaseService.getSchemePlanningClient().post(url, [role]);
    return response.data;
  },
  async getGroupRenderEmailAction({ commit }, payload) {
    const url = URI.GROUP_RENDER_EMAIL_URL
    .replace("{payload}", payload.groupNo)
    .replace("{groupTypeLkpId}", payload.groupTypeLkpId)
    .replace("{planAssociationId}", payload.planAssociationId);
    const response = await BaseService.getSchemePlanningClient().post(url, payload);
    return response.data;
  },
  async getScheduleGeneralDataDetails({ commit }, payload) {
    const url = URI.SCHEDULE_GENERAL_DATA_DETAILS_URL.replace(
      "{payload}",
      payload
    );
    const generalFormData = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setScheduleFormDetail", generalFormData.data.data);
    return generalFormData;
  },
  async cancelSubmitScheduleAction({ commit }, data) {
    let url = URI.CANCEL_SUBMIT_SCHDEULE.replace("{scheduleNumber}", data);
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async savePlanListDataAction({ commit }, payload) {
    let groupHdrIds = payload.groupHdrIds;
    let roleValues = payload.jobRoles.map((obj) => obj.value);
    let str = `emailGroupId=${payload.emailGroupId}&planNumber=${payload.planNumber}&scheduleNumber=${payload.scheduleNumber}`;
    if(payload.groupNumber && payload.tableTitle != "Planned Based") {
      str = payload.tableTitle == "Planned Based" ? str : `${str}&groupNumber=${payload.groupNumber}`;
    } 
    const url = URI.SAVE_PLAN_LIST_DATA_URL.replace("{str}", str);
    let payloaddata = {
      groupHdrIds: groupHdrIds,
      jobRoles: roleValues,
    };
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payloaddata
    );
    return response.data;
  },
  async saveHOMXPlanListDataAction({ commit }, payload) {
    let groupHdrIds = payload.groupHdrIds; //.map((obj) => obj.groupId);
    let str = `emailGroupId=${payload.emailGroupId}&planNumber=${payload.planNumber}&scheduleNumber=${payload.scheduleNumber}`;
    const url = URI.SAVE_HO_MX_PLAN_LIST_URL.replace("{str}", str);
    let payloaddata = {
      groupHdrIds: groupHdrIds,
      roles: [],
    };
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payloaddata
    );
    return response.data;
  },
  async getSchedulePlanListDetails({ commit }, payload) {
    const url = URI.SCHEDULE_PLAN_LIST_DETAILS_URL.replace(
      "{payload}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async getGroupListDropdownAction({ commit }, payload) {
    const url = URI.GROUP_LIST_DROPDOWN_URL.replace(
      "{payload}",
      payload.groupTypeId
    ).replace("{division}", payload.division);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  async associatedPlanAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.ADD_SCHEDULE_PLAN_URL,
      payload
    );
    return response.data;
  },
  async saveSubmittedSchedule({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().put(
      URI.SAVE_SUBMITTED_SCHEDULE_URL,
      payload
    );
    return response.data;
  },
  async getPlanAssociatedEmail({ commit }, payload) {
    const url = URI.PLAN_ASSOCIATED_EMAIL_URL.replace(
      "{emailGroupTypeId}",
      payload.emailGroupTypeId
    )
      .replace("{planNumber}", payload.planNumber)
      .replace("{scheduleNumber}", payload.scheduleNumber)
      .replace(
        "{currentPage}",
        payload.page.currentPage
      )
        .replace("{pageSize}", payload.page.pageSize)
        .replace("{value}", payload.sord.value)
        .replace("{sortOrder}", payload.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getFlagIfEmailPlanORGroup({ commit }, payload) {
    const url = URI.FLAG_FOR_EMAIL_PLAN_OR_GROUP_URL.replace(
      "{emailGroupTypeId}",
      payload.emailGroupTypeId
    )
      .replace("{planNumber}", payload.planNumber)
      .replace("{scheduleNumber}", payload.scheduleNumber);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async getPlanAssociatedEmailGroup({ commit }, payload) {
    const url = URI.PLAN_ASSOCIATION_EMAIL_GROUP_URL.replace(
      "{emailGroupTypeId}",
      payload.emailGroupTypeId
    )
      .replace("{planNumber}", payload.planNumber)
      .replace("{scheduleNumber}", payload.scheduleNumber)
      .replace("{planAssociationId}", payload.planAssociationId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async getRenderEmailListAction({ commit }, payload) {
    let url;
    if(payload.v == 'single') {
      url = URI.GET_EMAIL_RENDER_SINGLE_LIST_URL.replace("{planAssociationId}", payload.planAssociationId)
      .replace("{groupTypeLkpId}", payload.groupTypeLkpId)
      .replace(
        "{currentPage}",
        payload.page.currentPage
      )
        .replace("{pageSize}", payload.page.pageSize)
        .replace("{value}", payload.sord.value)
        .replace("{sortOrder}", payload.sord.__sortOrder)
        .replace("{scheduleMailingGroupId}", payload.scheduleMailingGroupId);
    } else {
      url = URI.GET_EMAIL_RENDER_MULTI_LIST_URL.replace("{planAssociationId}", payload.planAssociationId)
      .replace("{groupTypeLkpId}", payload.groupTypeLkpId)
      .replace(
        "{currentPage}",
        payload.page.currentPage
      )
        .replace("{pageSize}", payload.page.pageSize)
        .replace("{value}", payload.sord.value)
        .replace("{sortOrder}", payload.sord.__sortOrder);
    }
    const schemes = await BaseService.getSchemePlanningClient().get(url);
    return schemes.data.data;
  },
  async getAssociatedGroupBasedEmails({ commit }, payload) {
    const url = URI.ASSOCIATED_GROUP_BASED_EMAILS_URL.replace(
      "{emailGroupTypeId}",
      payload.emailGroupTypeId
    )
      .replace("{groupNumber}", payload.groupNumber)
      .replace("{planNumber}", payload.planNumber)
      .replace("{scheduleNumber}", payload.scheduleNumber)
      .replace("{currentPage}", payload.page.currentPage)
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getSubmitScheduleDetails({ commit }, payload) {
    const url = URI.SUBMIT_SCHEDULE_DETAILS_URL.replace("{payload}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async downloadEmailAttachmentExcel({ commit }, payload) {
    const url = URI.EMAIL_ATTACHMENT_EXPORT_FILE_URL.replace(
      "{fileId}",
      payload.fileId
    ).replace("{scheduleNo}", payload.scheduleNo);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadPartnerHoSalesGroupBasedExcel({ commit }, payload) {
      let url = URI.DOWNLOAD_GROUP_PARTNER_HO_SALES_FILE_URL.replace(
        "{groupTypeId}",
        payload.groupTypeId
      ).replace("{groupNo}", payload.groupNo)
      .replace("{planAssociationId}", payload.planAssociationId);
      if(!payload.jobRoles) {
        payload.jobRoles = [];
      }
      const response = await BaseService.getSchemePlanningClient().post(url, payload, {
        responseType: "blob",
      });
      return response;
  },
  async downloadPartnerHoSalesPlannedBasedExcel({ commit }, payload) {
    let url = URI.DOWNLOAD_PLANNED_PARTNER_SALES_FILE_URL.replace(
      "{groupTypeId}",
        payload.groupTypeId
      )
      .replace("{planAssociationId}", payload.planAssociationId)
      .replace("{planNumber}", payload.planNo);
      if(!payload.jobRoles) {
        payload.jobRoles = [];
      }
      const response = await BaseService.getSchemePlanningClient().post(url, payload, {
        responseType: "blob",
      });
      return response;
  },
  async downloadPartnerHoSalesExcel({ commit }, payload) {
    let url = "";
    let role = "";
    switch (payload.groupTypeId) {
      case 99: // Partner
      if(payload.tableTitle == 'Planned Based') {
        url = URI.DOWNLOAD_PARTNER_FILE_URL.replace(
          "{groupTypeId}",
          payload.groupTypeId
        )
        .replace("{planAssociationId}", payload.planAssociationId);
        if (payload.planNo) url = `${url}&planNumber=${payload.planNo}`;
      } else {
        url = URI.DOWNLOAD_PARTNER_FILE_URL.replace(
          "{groupTypeId}",
          payload.groupTypeId
        ).replace("{groupNo}", payload.groupNo)
        .replace("{planAssociationId}", payload.planAssociationId);
        if (payload.planNo) url = `${url}&planNumber=${payload.planNo}`;
      }
        break;
      case 101: // HO
      if(payload.tableTitle == 'Planned Based') {
        url = URI.DOWNLOAD_HO_FILE_URL.replace(
          "{groupTypeId}",
          payload.groupTypeId
        )
        .replace("{planAssociationId}", payload.planAssociationId);
      } else {
        url = URI.DOWNLOAD_HO_FILE_URL.replace(
          "{groupTypeId}",
          payload.groupTypeId
        ).replace("{groupNo}", payload.groupNo)
        .replace("{planAssociationId}", payload.planAssociationId);
      }
        break;
      case 100: // Sales
      if(payload.tableTitle == 'Planned Based') {
        url = URI.DOWNLOAD_SALES_FILE_URL.replace(
          "{groupTypeId}",
          payload.groupTypeId
        )
        .replace("{planAssociationId}", payload.planAssociationId);
        if (payload.planNo) url = `${url}&planNumber=${payload.planNo}`;
        if(payload.role) {
          role =  payload.role;
        }

      } else {
        url = URI.DOWNLOAD_SALES_FILE_URL.replace(
          "{groupTypeId}",
          payload.groupTypeId
        ).replace("{groupNo}", payload.groupNo)
        .replace("{planAssociationId}", payload.planAssociationId);
        if (payload.planNo) url = `${url}&planNumber=${payload.planNo}`;
        if(payload.role) {
          role =  payload.role;
        }
      }
        break;
      default:
        break;
      }
      const response = await BaseService.getSchemePlanningClient().post(url, [role], {
        responseType: "blob",
      });
      return response;
  },
  async getRolesAction({ commit }, payload) {
    const url = URI.ROLES_PARTNER_LIST_URL
    .replace("{divisionId}", payload.division)
    .replace("{audience}", payload.audience)
    .replace("{channelId}", payload.channelId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async schemePayoutScheduleAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SCHEME_PAYOUT_SCHEDULE_URL,
      payload
    );
    return response.data;
  },
  async partialPayoutDateItemAction({ commit }, payload) {
      let url = URI.PARTIAL_PAYOUT_DATE
      .replace("{programId}",payload.programId);
      const response = await BaseService.getSchemePlanningClient().get(url);
      commit("setpartialPayoutDateItem", response.data);
      return response.data;
  },
  async getPreviousPayoutCommunicationsForProgram({ commit }, payload) {
      let url = URI.PREVIOUS_PAYOUT_COMMUNICATION_FOR_PROGRAM;
      const response = await BaseService.getSchemePlanningClient().post(url,payload);
      commit("setPreviousPayoutCommunicationsForProgram", response.data.data);
      return response.data.data;
  },
  async storePreviousPastCommuAction({commit}, payload) {
    commit("setStorePreviousPastCommu", payload)

  },
  async getPartnerPayoutCommunicationAction({ commit }, payload) {
    let url = URI.PAYOUT_COMMUNICATION_PARTNER
    .replace("{payload}",payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getSalesPayoutCommunicationAction({ commit }, payload) {
    let url = URI.PAYOUT_COMMUNICATION_SALES
    .replace("{payload}",payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getHoPayoutCommunicationAction({ commit }, payload) {
    let url = URI.PAYOUT_COMMUNICATION_HO
    .replace("{payload}",payload)
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async payoutCommunicationSaveRenderEmail({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PAYOUT_COMMUNICATION_SAVE_RENDER_EMAIL,
      payload
    );
    return response.data;
  },
  async payoutCommunicationSalesSync({ commit }, payload) {
    let url = URI.PAYOUT_COMMUNICATION_SALES_SYNC
    .replace("{payload}",payload.flag);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async payoutCommunicationSaveschedule({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PAYOUT_COMMUNICATION_SAVE_SUBMIT_SCHEDULE,
      payload
    );
    return response.data;
  },
  async payoutCommunicationSaveRenderAllSchedule({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PAYOUT_COMMUNICATION_SAVE_RENDER_ALL_SCHEDULE,
      payload
    );
    return response.data;
  },
  async payoutCommunicationPartnerHOSalesDelete({ commit }, payload) {
    let url = URI.PAYOUT_COMMUNICATION_DELETE_GROUP
    .replace("{groupTypeId}",payload.groupTypeId);
    const response = await BaseService.getSchemePlanningClient().delete(
      url,
      {
        data: payload.data,
      }
    );
    return response.data;
  },
  async getPayoutCommunicationScheduledAction({ commit }, payload) {
    let url = URI.PAYOUT_COMMUNICATION_SCHEDULE
    .replace("{payload}",payload)
    // .replace("{programId}",payload.programId)
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getPayoutCommunicationGetDropdownPartnerHoSalesAction({ commit }, payload) {
    let url = URI.PAYOUT_COMMUNICATION_GET_DROPDOWN_PARTNER_HO_SALE
    .replace("{payload}",payload)
    let response = await BaseService.getSchemePlanningClient().get(url);
    response.data.data.url = payload
    commit("setPayoutCommunicationDropDownData", response.data.data);
    return response.data;
  },
  async payoutCommunicationAddPayoutGroup({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PAYOUT_COMMUNICATION_ADD_PAYOUT_GROUP,
      payload
    );
    return response.data;
  },
  async emailHoGroupsPayoutCommAction({ commit }, payload) {
    let channelIds = payload.channel.join(",");
    const url = URI.EMAIL_HO_GROUP_PAYOUT_COMM.replace(
      "{payload}",
      payload.groupTypeId
    ).replace("{division}", payload.division)
    .replace("{channel}", channelIds)
    .replace("{scheduleId}", payload.scheduleId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getUserCodeList({ commit }, payload) {
    let url = URI.USER_CODE_LIST.replace(
      "{search}",
      payload.searchTerm
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response;
  },
  async planListGroupedBasedStageDataDelete({ commit }, payload) {
    let url = URI.PLAN_LIST_GROUP_BASED_STAGE_DATA_DELETE
    .replace("{groupTypeLkpId}", payload.groupTypeLkpId)
    .replace("{planAssociationId}", payload.planAssociationId)
    .replace("{groupId}", payload.groupId)
    const response = await BaseService.getSchemePlanningClient().delete(
      url,
      {
        data: payload.data,
      }
    );
    return response.data;
  },
  async scheduleBulkEmail({ commit }, payload) {
    let url = URI.SCHEDULE_BULK_EMAIL
    const response = await BaseService.getSchemePlanningClient().post(url, payload);
    return response.data;
  },
  async scheduleJobRoleNamesBulk({ commit }, payload) {
    let url = URI.SCHEDULE_JOB_ROLE_NAME_BULK
    const response = await BaseService.getSchemePlanningClient().post(url, payload);
    return response.data;
  },
  async schedulePlanRenderEmailUploadErrorfileDownloadAction({ commit }, payload) {
      let url = URI.SCHEDULE_PLAN_RENDER_EMAIL_UPLOAD_ERROR_FILE_DOWNLOAD
        .replace("{scheduleNo}", payload.scheduleNo)
      const response = await BaseService.getSchemePlanningClient().get(url, {
        responseType: "blob",
      });
      return response;
    },
    async payoutCommInProgressAsyncFunAction({ commit }, payload) {
      let url = URI.PAYOUT_COMMUNICATION_IN_PROGRESS_ASYNC;
      const response = await BaseService.getSchemePlanningClient().post(url,payload);
      commit("setPayoutCommInProgressAsync", response.data.data);
      return response.data.data;
  },
  async downloadExcelpartnerOnlyPayoutCommunicationAction({ commit }, payload) {
    const url = URI.PARTNER_ONLY_EXPORT_PAYOUT_COMMUNICATION;
    const response = await BaseService.getSchemePlanningClient().post(url, payload, {
      responseType: "blob",
    });
    return response;
  },
  async partialSucceededStatusAction({ commit }, payload) {
    let url = URI.PARTIAL_SUCCEEDED_STATUS.replace(
      "{scheduleId}",
      payload.scheduleId
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async downloadExcelPartiallySucceededAction({ commit }, payload) {
    const url = URI.PARTIAL_SUCCEEDED_STATUS_DOWNLOAD.replace(
      "{scheduleId}",
      payload.scheduleId
    );
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
};

export default action;
